<template>
    <b-modal ref="profile_modal"
             size="xl"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>
        
        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        
        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 v-if="doc.id > 0">
                    <span class="fw-300">ID:{{this.doc.id}} | {{this.doc.name}}</span>
                </h2>
                
                <h2 v-else>
                    Створення
                </h2>
                
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>
            
            <div class="panel-container show">
                <b-overlay :show="is_load" rounded="sm">
                    <div class="panel-content">
                        <div class="d-flex flex-column align-items-center justify-content-center p-4">
                            <h5 class="mb-0 fw-700 text-center mt-3" v-if="doc.id > 0">
                                {{this.doc.id}}
                            </h5>
                            
                            <h6>
                                {{this.doc.number}}
                            </h6>
                        </div>
                        
                        <div>
                            <b-tabs content-class="mt-3">
                                <b-tab v-for="(tab,index) in tabs" @click="set_active(index)"
                                       :disabled="tab.disabled"
                                       :title="get_tab_title(tab)"
                                       :key="index"
                                       :active="tab.is_active"
                                >
                                    <template slot="title">
                                        {{get_tab_title(tab)}}
                                        <b-spinner type="grow" small v-if="tab.is_load"></b-spinner>
                                    </template>
                                    <component v-bind:is="tab.index" :doc="doc"></component>
                                </b-tab>
                            </b-tabs>
                        </div>
                    </div>
                </b-overlay>
            </div>
            <!--FOOTER -->
        </div>
        
        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
            
                <button type="button" v-on:click="change_state" class="btn btn-warning waves-effect waves-themed mr-5 pr-5" v-if="doc.id > 0">
                    {{ change_state_title }}
                </button>
       
                <button type="button" v-on:click="save_it" class="btn btn-success waves-effect waves-themed">
                    Зберегти
                </button>
                
                <button type="button" v-on:click="close_mod" class="btn btn-secondary waves-effect waves-themed">
                    Закрити
                </button>
                
            </div>
        </template>
    </b-modal>
</template>

<script>

import internal_main from "./tabs/internal_main.vue";
import internal_direction from "./tabs/internal_direction.vue";
import internal_files from "./tabs/internal_files.vue";
import internal_notification from "./tabs/internal_notification.vue";
import internal_permission from "./tabs/internal_permission.vue";


export default {
    name: "edit_internal",
    components : {
        internal_main,
        internal_direction,
        internal_files,
        internal_notification,
        internal_permission
    },
    data() {
        return  {
            is_show_modal   : false,
            is_load         : false,
            
            doc: {
                id : 0,
                state : 1,
                tov_id : 0,
                user_id : 0,
                number : "",
                doc_date : "",
                description : "",
                title : "",
                service_directions : [],
                attached_invoices : [],
                attached_adjust : [],
                files : [],
            },
            tabs:[
                {
                    title: "Основні",
                    index : "internal_main"
                },
                {
                    title: "Напрямки",
                    index : "internal_direction"
                },
                {
                    title: "Файли",
                    index : "internal_files"
                },
                
                {
                    title: "Повідомлення",
                    index : "internal_notification"
                },
                
                {
                    title: "Доступ",
                    index : "internal_permission"
                },
                
            ]
        }
    },
    
    created() {
        EventBus.$on("edit_doc",res => this.work_click(res));
        EventBus.$on("remove_internal_doc",res => this.remove(res));
    },
    
    
    methods : {
     
        async change_state() {
            this.is_load = true;
            await api.patch('/internal/docs/' + this.doc.id + "/state")
                .then(({data}) => {
                    this.is_load = false;
                    if(data.status == 'operation_success') {
                        this.doc = data.data;
                    }
                }).catch(err => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
        },
        
        close_mod() {
            this.close();
        },
        
        close() {
            this.question = this.default_quest;
            //	this.tabs = [];
            this.is_show_modal = false;
            
        },
        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },
        
        set_active (obj) {
            for (let tab in this.tabs) {
                this.tabs[tab].is_active = false;
            }
            
            this.tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
        },
        
        work_click(_id) {
            this.doc = this.default_item;
            if(_id > 0) {
                this.loadItem(_id);
            }
            this.is_show_modal = true;
        },
        
        async loadItem(_id) {
            this.is_load = true;
            this.doc = this.default_item;
            
            await api.get('/internal/docs/' + _id)
                .then(({data}) => {
                    this.is_load = false;
                    if(data.status == 'operation_success') {
                        this.doc = data.data;
                    }
                }).catch(err => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
        },
        
        
        async remove(id) {
            const is_ok = confirm_imc('Видалити ?');
            is_ok.then(res => {
                api.delete('/internal/docs/' + id).then(({data}) => {
                    if (data.status == "operation_success") {
                        window.location.reload();
                    }
                }).catch(err => {
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
            });
        },
        
        async save_it() {
            this.is_load = true;
            await api.put('/internal/docs/' + this.doc.id,this.doc).then(({data}) => {
                    this.is_load = false;
                    if(data.status == 'operation_success') {
                        this.doc = data.data;
                    }
                }).catch(err => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                });
        },
    },
    
    
    computed : {
        
        
        change_state_title() {
            if(this.doc.state) {
                return 'В архів';
            }
            
            return 'Вилучити з архіву';
        },
        
        
        cur_user() {
            return this.$store.state.common.imc_core_const;
        },
        
        default_item () {
            return {
                id : 0,
                tov_id : 0,
                user_id : 0,
                state : 1,
                number : "",
                doc_date : "",
                description : "",
                title : "",
                service_directions : [],
                attached_invoices : [],
                attached_adjust : [],
                files : [],
            }
        },
        
        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }
            
            return "modal-dialog-left modal-lg";
        },
        
    }
}
</script>

<style scoped>

</style>
